import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isAndroid, isIOS } from 'react-device-detect'
import { isNative } from '@dhl/webview'

export const trackingEnvironment = (): string => {
  if (!isNative()) {
    return 'Web browser'
  }

  if (isAndroid) {
    return 'Native Android'
  }

  if (isIOS) {
    return 'Native iOS'
  }

  return 'Unknown'
}

export const useVirtualPageViews = (isEnabled: boolean, rootPath?: string, isLoggedIn?: boolean): void => {
  const { pathname } = useLocation()

  useEffect(() => {
    if (isEnabled) {
      window.dataLayer.push({
        event: 'VirtualPageview',
        virtualPageURL: rootPath ? `/${rootPath}${pathname}` : pathname,
        trackingEnvironment: trackingEnvironment(),
        loggedInState: isLoggedIn ? 'logged_in' : 'logged_out',
      })
    }
  }, [pathname, rootPath, isEnabled, isLoggedIn])
}
